export const MAIN_STRIKERS_TO_SHOW =
  typeof window !== 'undefined' && window.innerWidth < 900 ? 6 : 15;
